import axiosInstance from "./axiosInstance";

function authHeader(token?: string) {
  if (!token || token.trim().length === 0) return {};
  return { Authorization: `Bearer ${token}` };
}

export type ParameterRequestStatus = "OPEN" | "DONE";

/** OpenAPI `ParameterRequestDTO`. */
export interface ParameterRequestDTO {
  id: string;
  version: number;
  requesterId: number;
  categoryId: string;
  /** Current category name, resolved server-side at read time (never stale). */
  categoryName: string;
  text: string;
  status: ParameterRequestStatus;
  createdAt?: string;
}

/** Files a request for a new parameter on an existing category. */
export async function createParameterRequest(
  token: string,
  categoryId: string,
  text: string
): Promise<ParameterRequestDTO> {
  const response = await axiosInstance.post<ParameterRequestDTO>(
    "/parameterRequests",
    { categoryId, text },
    { headers: authHeader(token) }
  );
  return response.data;
}

/** Lists parameter requests by status (admin). */
export async function listParameterRequests(
  token: string,
  status: ParameterRequestStatus = "OPEN"
): Promise<ParameterRequestDTO[]> {
  const response = await axiosInstance.get<ParameterRequestDTO[]>(
    "/parameterRequests",
    { headers: authHeader(token), params: { status } }
  );
  return response.data ?? [];
}

/** Sets a request's status, e.g. mark DONE once the parameter was added (admin). */
export async function setParameterRequestStatus(
  token: string,
  id: string,
  version: number,
  status: ParameterRequestStatus
): Promise<ParameterRequestDTO> {
  const response = await axiosInstance.patch<ParameterRequestDTO>(
    "/parameterRequests",
    { id, version, status },
    { headers: authHeader(token) }
  );
  return response.data;
}